import { LoadingButton } from '@mui/lab';
import { Box, TextField, Typography } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { handleError } from '../../../../shared/functions/handleError';
import { AuthService } from '../../service';

const ForgotEmailForm = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setIsLoading(true);
    await AuthService.sendPasswordOtp(email)
      .then((response) => {
        if (response) {
          enqueueSnackbar(t('toasts.otpSent', { email }), {
            variant: 'success',
          });
          navigate('/');
        }
      })
      .catch(handleError)
      .finally(() => setIsLoading(false));
  };
  return (
    <form
      onSubmit={handleSubmit}
      style={{
        width: '75%',
      }}
    >
      <Typography variant="h4">
        {t('general.reset.resetPassword')} 🔒
      </Typography>

      <Typography variant="subtitle1">
        {t('general.reset.resetPasswordDesc')}
      </Typography>
      <Box sx={{ margin: '20px 0' }}>
        <TextField
          value={email ?? ''}
          onChange={(e) => setEmail(e.target.value)}
          label={t('general.login.email')}
          sx={{ width: '100%' }}
        />
      </Box>
      <LoadingButton
        loading={isLoading}
        variant={'contained'}
        sx={{ width: '100%' }}
        type={'submit'}
        disabled={!email?.length}
      >
        {t('button.resetPassword')}
      </LoadingButton>
    </form>
  );
};

export default ForgotEmailForm;
